import * as z from "zod/v4/mini";
import { ProtocolSchemas } from "../../utils/protocol-schemas.js";
const authFields = {
    mfaRequired: z.optional(z.boolean()),
    mfaEmailSent: z.optional(z.boolean()),
    mfaExpireDate: z.optional(z.string()),
    token: z.optional(z.string()),
    tenantCode: z.optional(z.string()),
    userTenantToken: z.optional(z.string()),
    userId: z.optional(z.string()),
    name: z.optional(z.string()),
    email: z.optional(z.string()),
    expireDate: z.optional(z.string()),
    title: z.optional(z.string()),
    pictureUrl: z.optional(z.string()),
    roles: z.optional(z.array(z.string())),
    groups: z.optional(z.array(z.string())),
};
export const authOutcomeSchema = z.looseObject({
    ...authFields,
    status: z.optional(ProtocolSchemas.number()),
    message: z.optional(z.string()),
    auth: z.optional(z.looseObject(authFields)),
});
export const verifyOutcomeSchema = z.looseObject({
    ...authFields,
    status: z.optional(ProtocolSchemas.number()),
    message: z.optional(z.string()),
    auth: z.optional(z.looseObject({
        ...authFields,
        positions: z.optional(z.array(z.string())),
        isPublic: z.optional(z.boolean()),
    })),
});
//# sourceMappingURL=auth-outcome-schema.js.map